import { ContentLoading } from '@/components/common/content-loading';
import HorizontalView from '@/components/feature/parking/horizontal-view';
import VerticalView from '@/components/feature/parking/vertical-view';
import { useOrientation } from '@/hooks';
import { Suspense } from 'react';

interface ParkingPageProps {
    readonly gnbMenuId?: string;
}

export default function ParkingPage({ gnbMenuId }: ParkingPageProps) {
    const { isHorizontal } = useOrientation();

    return (
        <main className="relative h-full w-full overflow-hidden">
            <Suspense fallback={<ContentLoading loading />}>
                {isHorizontal ? <HorizontalView key="horizontal" gnbMenuId={gnbMenuId} /> : <VerticalView key="vertical" gnbMenuId={gnbMenuId} />}
            </Suspense>
        </main>
    );
}
